import { render, staticRenderFns } from "./mqDec.vue?vue&type=template&id=35c58ad3&scoped=true"
import script from "./mqDec.vue?vue&type=script&lang=js"
export * from "./mqDec.vue?vue&type=script&lang=js"
import style0 from "./mqDec.vue?vue&type=style&index=0&id=35c58ad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c58ad3",
  null
  
)

export default component.exports